import app from 'app';
import Marionette from 'backbone.marionette';

app.namespace.Controller.Extension = Marionette.Object.extend({
  initialize: function () {
    this._bSupported =
      window.chrome &&
      window.chrome.runtime &&
      'function' === typeof window.chrome.runtime.sendMessage;

    this._bEnabledSpeak =
      app.rootStore.getters['user/box'].isDev() ||
      app.rootStore.getters['user/type'].WOCHIT_INTERNAL;
  },

  /**
   * @return void
   */
  gotoExtensionHome: function () {
    const { name, id } = app.config.chromeExtension;
    if (name && id) {
      window.open(
        `https://chrome.google.com/webstore/detail/${name}/${id}`,
        '_blank'
      );
    }
  },

  /**
   * @return {Promise}
   */
  getManifest: function () {
    const deferred = new $.Deferred();
    if (!this._bSupported) {
      deferred.reject();
      return deferred.promise();
    }

    window.chrome.runtime.sendMessage(
      app.config.chromeExtension.id,
      { message: 'version' },
      (manifest) => {
        if (_.isEmpty(manifest)) {
          deferred.reject();
        } else {
          deferred.resolve();
        }
      }
    );

    return deferred.promise();
  },

  /**
   * @return {Promise}
   */
  speak: function (what) {
    const deferred = new $.Deferred();
    if (!this._bSupported || !this._bEnabledSpeak) {
      deferred.reject();
      return deferred.promise();
    }

    window.chrome.runtime.sendMessage(
      app.config.chromeExtension.id,
      { message: 'speak', what: what },
      (response) => {
        if (response && response.error) {
          deferred.reject(response);
        } else {
          deferred.resolve(response);
        }
      }
    );

    return deferred.promise();
  },
});
